"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormMigrateModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var store_1 = require("../../store");
var collection_form_migrate_modal_ctrl_1 = require("./collection.form.migrate.modal.ctrl");
var collection_form_migrate_modal_style_1 = require("./collection.form.migrate.modal.style");
(0, theme_1.addStyles)(collection_form_migrate_modal_style_1.Style);
var CollectionFormMigrateModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionFormMigrateModal, _super);
    function CollectionFormMigrateModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.departmentForms = [];
        _this.errors = [];
        _this.selectedFormRevision = null;
        _this.ctrl = new collection_form_migrate_modal_ctrl_1.CollectionFormMigrateModalCtrl(collections);
        _this.errorState = new input_state_1.InputState(i18n_1.T.ERROR);
        _this.loadingState = new input_state_1.InputState(i18n_1.T.LOADING);
        _this.addState(_this.errorState);
        _this.addState(_this.loadingState);
        store_1.AppStore.FormSummary.refresh();
        return _this;
    }
    Object.defineProperty(CollectionFormMigrateModal.prototype, "nodes", {
        get: function () {
            var _this = this;
            var _a;
            this.departmentForms = store_1.AppStore.FormSummary.all;
            if (this.departmentForms.length === 0) {
                this.loadingState.setError(i18n_1.T.LOADING);
                return spinner_1.Spinner.view();
            }
            var collectionFormRevision = (_a = this.ctrl.collections[0]) === null || _a === void 0 ? void 0 : _a.formRevision;
            var filteredForms = this.departmentForms.filter(function (form) {
                return form.metadata
                    && (form.metadata.ocalc
                        || form.metadata.spidacalc
                        || form.metadata.poleforeman
                        || form.metadata.ikePoleForeman
                        || form.metadata.dds) && form.revision !== collectionFormRevision;
            });
            if (filteredForms.length === 0) {
                return (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_NO_FORMS));
            }
            this.loadingState.reset();
            if (!this.selectedFormRevision) {
                this.selectedFormRevision = filteredForms[0].revision;
            }
            return (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.warningTitle }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE)),
                    (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.warningBody }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1)),
                    (0, mithril_1.m)('div', { className: collection_form_migrate_modal_style_1.CSS.body }, [
                        (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2)),
                        (0, mithril_1.m)('ul', [
                            (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3)),
                            (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4))
                        ]),
                        (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY))
                    ])
                ]),
                (0, mithril_1.m)('select', {
                    onchange: function (e) {
                        if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                            _this.selectedFormRevision = e.target.value;
                        }
                    }
                }, filteredForms.map(function (form) { return (0, mithril_1.m)('option', { value: form.revision }, "".concat(form.displayname, " (V").concat(form.displayversion, ")")); }))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    CollectionFormMigrateModal.prototype.failToChange = function () {
        this.errors = this.ctrl.failures;
        this.errorState.setError(i18n_1.T.ERROR);
        notification_service_1.NotificationService.error({ key: i18n_1.T.COLLECTION_MIGRATE_FORM_FAIL });
    };
    CollectionFormMigrateModal.prototype.submit = function () {
        if (this.selectedFormRevision) {
            return this.ctrl.updateFormCollections(this.selectedFormRevision);
        }
        else {
            return null;
        }
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormMigrateModal.prototype, "errors", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormMigrateModal.prototype, "selectedFormRevision", void 0);
    return CollectionFormMigrateModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionFormMigrateModal = CollectionFormMigrateModal;
//# sourceMappingURL=collection.form.migrate.modal.js.map